import script from "./aiColorMatchingTab.vue?vue&type=script&setup=true&name=aiColorMatching&lang=js"
export * from "./aiColorMatchingTab.vue?vue&type=script&setup=true&name=aiColorMatching&lang=js"

const __exports__ = script;

export default __exports__